import { useEffect, useState } from 'react';

import Popup from '../../../components/popup';
import Checkbox from '../../../components/checkbox';

import { ProceedButton, CancelButton } from '../../../components/buttons';

export default ({ setPopup, contentId, onSuccess }) => {
    const confirm = () => {}

    return (
        <Popup type="manage-staff">
            <div class="popup__inner">
                <h1>Remove Staff Member: Firstname Lastname</h1>

                <p className="manage-staff__warning">
                    Please ensure that the user has exported any important data related to this account or that another user can manage this data. If you require support or have a question, please contact us
                </p>

                <div class="popup__buttons">
                    <ProceedButton responsive={false} onClick={confirm}>Confirm</ProceedButton>
                    <CancelButton responsive={false} onClick={() => setPopup(false)}/>
                </div>
            </div>
        </Popup>
    )
}
